export default __webpack_public_path__ + "static/media/gallery_07.a4996789.jpg";